module.exports = __webpack_public_path__ + "img/title-5.19b2784a.png";